import React, { useState } from "react";
import { Draggable } from "react-beautiful-dnd";

import { SideMenuItem } from "./SideMenuItem";
import { IMenuItem } from "shared/components/SideMenu/types";
import { Move } from "shared/assets/icons";
import { Tooltip } from "shared/components/Tooltip/Tooltip";

interface DraggableMenuItemProps extends IMenuItem {
  index: number;
  dragEnabled?: boolean;
  isActive?: boolean;
  dragTooltipCopy?: string;
  expandedItemId: string | null;
  setExpandedItemId: (id: string | null) => void;
  handleClose?: () => void;
}

export const DraggableMenuItem: React.FC<DraggableMenuItemProps> = ({
  id,
  index,
  icon,
  dragEnabled,
  dragTooltipCopy,
  ...rest
}) => {
  const [referenceElement, setReferenceElement] = useState<Element | null>();

  return (
    <>
      <Tooltip content={dragTooltipCopy} referenceElement={referenceElement} />
      <Draggable draggableId={id} index={index}>
        {(provided, snapshot) => (
          <SideMenuItem
            innerRef={provided.innerRef}
            {...provided.draggableProps}
            dragHandleProps={provided.dragHandleProps}
            isDragging={snapshot.isDragging}
            id={id}
            icon={dragEnabled ? Move : icon}
            setDragRef={setReferenceElement}
            {...rest}
          />
        )}
      </Draggable>
    </>
  );
};
